import { STUDENT_IMAGE_UPLOAD_ACCEPT } from "@core/shared/utils/uploaded-file-types";
import { trans } from "@mongez/localization";
import { FaCheck, FaTimes, FaUpload } from "react-icons/fa";
import { usePaymentMethodReceiptUpload } from "../hooks";

export function ReceiptUpload() {
  const { receiptFile, isPreparing, uploadFile, removeFile } =
    usePaymentMethodReceiptUpload();

  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-4">
      <div className="mb-3 flex items-center space-x-2">
        <FaUpload className="text-primary" />
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">
          {trans("invoices.uploadPaymentReceipt")}
        </h3>
      </div>
      <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
        {trans("invoices.uploadPaymentReceiptDescription")}
      </p>

      <div className="space-y-3">
        <input
          type="file"
          accept={STUDENT_IMAGE_UPLOAD_ACCEPT}
          onChange={uploadFile}
          disabled={isPreparing}
          className="hidden"
          id="receipt-upload"
        />
        <label
          htmlFor="receipt-upload"
          className="block w-full cursor-pointer rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 p-4 text-center transition-colors hover:border-primary hover:bg-primary/5 dark:hover:bg-primary/10"
        >
          <FaUpload className="mx-auto mb-2 text-gray-400 dark:text-gray-500" size={24} />
          <span className="text-sm text-gray-600 dark:text-gray-300">
            {isPreparing
              ? trans("invoices.preparingReceipt")
              : receiptFile
                ? receiptFile.name
                : trans("invoices.clickToUpload")}
          </span>
        </label>

        {receiptFile && (
          <div className="flex items-center justify-between rounded-lg border border-green-200 dark:border-green-700 bg-green-50 dark:bg-green-900/20 p-3">
            <div className="flex items-center space-x-2">
              <FaCheck className="text-green-600 dark:text-green-400" />
              <span className="text-sm text-green-800 dark:text-green-200">{receiptFile.name}</span>
            </div>
            <button
              onClick={removeFile}
              className="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
            >
              <FaTimes size={14} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
